import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { TranslationKeyWithCssClass, WorkflowVisibility } from '@ca/core/models';

@Component({
    selector: 'ca-workflow-badge',
    templateUrl: './workflow-badge.component.html',
    styleUrls: ['../badge.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class WorkflowBadgeComponent {
    @Input() visibility: WorkflowVisibility = 'Private';

    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    WORKFLOW_BADGE_LABELS_MAP: { [key in WorkflowVisibility]: TranslationKeyWithCssClass } = {
        Rejected: { translationKey: 'WORKFLOWS.BADGE_LABEL.IMPROVEMENTS_NEEDED', cssClass: 'type-improvements-needed' },
        Public: { translationKey: 'WORKFLOWS.BADGE_LABEL.PUBLIC', cssClass: 'type-public' },
        Submitted: { translationKey: 'WORKFLOWS.BADGE_LABEL.SUBMITTED', cssClass: 'type-submitted' },
        Private: { translationKey: 'WORKFLOWS.BADGE_LABEL.PRIVATE', cssClass: 'type-private' },
        Draft: { translationKey: 'WORKFLOWS.BADGE_LABEL.DRAFT', cssClass: 'type-draft' },
        Unpublished: { translationKey: 'WORKFLOWS.BADGE_LABEL.UNPUBLISHED', cssClass: 'type-unpublished' },
    };
}
